import { Cache } from '@app/utils/cache/cache';
import { InMemoryCache } from '@app/utils/cache/in-memory-cache';

export function DefaultCache(): Cache {
  return InMemoryCache;
}
